var map = {
	"./admin/stats": 32,
	"./admin/stats.jsx": 32,
	"./clients/quote": 33,
	"./clients/quote.jsx": 33,
	"./shared/address": 20,
	"./shared/address.jsx": 20,
	"./shared/addresses": 21,
	"./shared/addresses.jsx": 21,
	"./shared/map": 42,
	"./shared/map.jsx": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;